import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { BarMenu, BarMenuSerializers } from './models/IBarMenu';

const barMenuService = {
  getBarMenuList(barInfoId: number): Promise<CommonResponse<Array<BarMenu>>> {
    const url = `/bar-guide-menu`;
    return axiosClient.get(url, { params: { id: barInfoId } });
  },
  deleteBarMenuList(params: Array<number>): Promise<CommonResponse<Array<BarMenu>>> {
    const url = `/bar-guide-menu`;
    return axiosClient.delete(url, { data: params });
  },
  addNewBarMenu(params: Array<BarMenuSerializers>): Promise<CommonResponse<Array<BarMenu>>> {
    const url = `/bar-guide-menu`;
    return axiosClient.post(url, params);
  },
};

export default barMenuService;
